/**
 * הגדרת מסע ההכרזה על יכולות חדשות.
 *
 * `version` — מזהה הסבב הנוכחי. שינוי שלו מאפס את המונה אצל כל המשתמשים
 * ומתחיל סבב חדש (כל משתמש יופנה שוב אוטומטית לגרסה החדשה).
 * `autoShowTimes` — כמה כניסות לתוכנה להפנות אוטומטית לדף "מה חדש".
 * אחרי זה הדף נשאר בתפריט, בלי הפניה אוטומטית.
 */
export const ANNOUNCEMENT = {
    version: '2026-08-v1',
    autoShowTimes: 3,
    enabled: false
};

/**
 * `false` — מסתיר את קטלוג היכולות, ההילה והפניה האוטומטית אצל כולם.
 */
export const SHOW_FEATURE_CATALOG = true;

/** האם להציג את גריד היכולות, ההילה והפניה האוטומטית */
export function isFeatureCatalogVisible(): boolean {
    return SHOW_FEATURE_CATALOG;
}

/**
 * נתיבים שבהם לא מפריעים למשתמש גם אם הגיע הזמן להכריז — עבודה בתהליך
 * (יצירת מסמך), מסך הזמנות מגע, או כניסה עם `?code=` מהחשבונית-ישראל
 * שמטופלת ב-AuthGuard.
 */
export const ANNOUNCEMENT_SKIP_PATHS = ['/documents/create', '/order_touch', '/login', '/register'];
